@if (isUnified) {
  <!-- Unified Code: middle banner on the primary colour; on-colour text and a clear CTA (criteria 2, 28). -->
  <div class="uc-home-section uc-middle-banner" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-middle-banner__inner">
        <div class="uc-middle-banner__media d-none d-lg-block">
          <img loading="lazy" [src]="image" alt="">
        </div>
        <div class="uc-middle-banner__content">
          <h2 class="uc-display-sm uc-semibold">{{ title || ("home.middleBanner.title" | translate) }}</h2>
          <p class="uc-text-lg">{{ description || ("home.middleBanner.description" | translate) }}</p>
          <a class="btn uc-btn-primary-on-color" routerLink="/course">
            {{ "home.seeMore" | translate }}
            <i class="fa-solid" [ngClass]="isRtl ? 'fa-arrow-left' : 'fa-arrow-right'" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
} @else {
<section [dir]="isRtl ? 'rtl' : 'ltr'">
  <div class="container-fluid h-100">
    <div class="row align-items-center justify-content-center justify-content-lg-start h-100">
      <div class="col px-0 h-100 d-none d-lg-flex">
        <img loading="lazy" class="w-100 h-100" [src]="image" alt="">
      </div>
      <div class="col h-100">
        <div class="container h-100">
          <div class="row h-100 middle-banner-details align-items-center text-white">
            <div class="col-12 col-lg-8" >
              <h2 *ngIf="title; else defaultTitle">{{ title }}</h2>
              <ng-template #defaultTitle>
                <h2 translate="home.middleBanner.title"></h2>
              </ng-template>
              <p class="mb-0" *ngIf="description; else defaultDescription">{{ description }}</p>
              <ng-template #defaultDescription>
                <p class="mb-0" translate="home.middleBanner.description"></p>
              </ng-template>
            </div>
            <div class="col-12 col-lg-4">
              <a class="course-btn mx-auto border d-block rounded-circle d-flex align-items-center justify-content-center" routerLink="/course">
                <i class="fa-solid d-block" [ngClass]="isRtl? 'fa-arrow-left':'fa-arrow-right'"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}
